var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 111,
    viewBox: "0 0 119 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.66 42.42C71.2899 42.42 62.77 42.08 54.7999 39.86C46.9799 37.69 39.7999 33.48 33.3999 28.61C29.2099 25.44 25.3999 22.92 19.9599 23.3C14.6335 23.5916 9.54234 25.5902 5.43995 29C-1.48005 35 -0.440053 46.23 2.32995 54.12C6.48995 66 19.1499 74.23 29.9099 79.61C42.34 85.82 56 89.42 69.6899 91.5C81.6899 93.32 97.1099 94.65 107.51 86.81C117.06 79.61 119.68 63.17 117.34 52.07C116.773 48.7879 115.027 45.8258 112.43 43.74C105.72 38.84 95.7099 42.11 88.1699 42.28C85.3699 42.34 82.52 42.41 79.66 42.42Z",
    fill: "#3B0069",
    fillOpacity: 0.458824
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.18 110.95C79.4543 110.95 95.89 109.925 95.89 108.66C95.89 107.395 79.4543 106.37 59.18 106.37C38.9056 106.37 22.47 107.395 22.47 108.66C22.47 109.925 38.9056 110.95 59.18 110.95Z",
    fill: "#3B0069",
    fillOpacity: 0.458824
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6899 30.2V34.51",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.54 32.36H98.84",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.47 66.42V70.72",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3101 68.57H26.6201",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4399 12.28V16.58",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 14.43H20.59",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3001 2.30003C65.8413 2.30003 66.2801 1.86127 66.2801 1.32003C66.2801 0.778787 65.8413 0.340027 65.3001 0.340027C64.7588 0.340027 64.3201 0.778787 64.3201 1.32003C64.3201 1.86127 64.7588 2.30003 65.3001 2.30003Z",
    fill: "#3B0069",
    fillOpacity: 0.501961
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.96 97.9C63.5012 97.9 63.94 97.4612 63.94 96.92C63.94 96.3788 63.5012 95.94 62.96 95.94C62.4187 95.94 61.98 96.3788 61.98 96.92C61.98 97.4612 62.4187 97.9 62.96 97.9Z",
    fill: "#3B0069",
    fillOpacity: 0.501961
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0055 6.97655L26.9723 12.9005C25.6704 13.0358 24.7246 14.2008 24.8598 15.5027L32.66 90.5987C32.7952 91.9006 33.9603 92.8464 35.2622 92.7112L92.2953 86.7872C93.5972 86.6519 94.543 85.4869 94.4078 84.185L86.6076 9.08901C86.4724 7.7871 85.3074 6.84132 84.0055 6.97655Z",
    fill: "#3B0069",
    fillOpacity: 0.91
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5513 10.4429L30.0783 15.7893C28.7764 15.9246 27.8306 17.0896 27.9658 18.3915L35.02 86.3061C35.1553 87.608 36.3203 88.5538 37.6222 88.4186L89.0953 83.0721C90.3972 82.9369 91.343 81.7719 91.2077 80.47L84.1535 12.5553C84.0183 11.2534 82.8533 10.3076 81.5513 10.4429Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.67 13.77L71.87 6.07C71.8299 5.75041 71.6661 5.45929 71.4136 5.25922C71.1612 5.05914 70.8404 4.96607 70.52 5L61 6C60.9226 5.23177 60.6945 4.48632 60.329 3.80622C59.9634 3.12611 59.4674 2.52467 58.8694 2.03624C58.2714 1.5478 57.5831 1.18193 56.8437 0.959527C56.1043 0.737119 55.3283 0.662524 54.56 0.740004C53.7918 0.817484 53.0464 1.04552 52.3663 1.41109C51.6862 1.77666 51.0847 2.27261 50.5963 2.87062C49.6098 4.07836 49.1436 5.62849 49.3 7.18L39.75 8.18C39.5891 8.19625 39.433 8.24407 39.2905 8.32075C39.1481 8.39742 39.0222 8.50143 38.92 8.62683C38.8178 8.75223 38.7414 8.89655 38.6951 9.05153C38.6488 9.20651 38.6334 9.3691 38.65 9.53001L39.45 17.23C39.4663 17.3909 39.5141 17.5471 39.5908 17.6895C39.6675 17.832 39.7715 17.9579 39.8969 18.06C40.0223 18.1622 40.1666 18.2387 40.3216 18.285C40.4766 18.3313 40.6391 18.3466 40.8 18.33L71.58 15.13C71.7416 15.1139 71.8982 15.0657 72.0409 14.9882C72.1835 14.9108 72.3093 14.8057 72.4108 14.679C72.5123 14.5524 72.5875 14.4067 72.632 14.2506C72.6766 14.0946 72.6895 13.9312 72.67 13.77Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9199 60.71C48.2474 57.7426 49.581 54.9767 51.6988 52.8725C53.8166 50.7682 56.5909 49.4524 59.5604 49.1438C62.5299 48.8353 65.5155 49.5527 68.0206 51.1767C70.5257 52.8007 72.3994 55.2333 73.3299 58.07",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3801 37.81L44.5901 43.71",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.04 38.37L49.93 43.15",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.54 35.41L67.75 41.3",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 35.96L73.09 40.75",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.8e706910ab6a5d5d50703da8a000fff8.svg";
export { ForwardRef as ReactComponent };